import { Badge } from "@/components/Badge";
import Icon from "@/components/Icon/Icon";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TextVariant } from "@/components/Typography/Text.variant";
import { Separator } from "@/components/ui/separator";
import { defaultNS, useTranslation } from "@/lib/i18n";

import type { SoftwareDetailRes } from "../_$id/-query/type";

export default function SoftwareStatusSummary({
  software,
}: {
  software: SoftwareDetailRes;
}) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.profile.software.header",
  });

  // 新しいスキーマでは、これらの情報は別のAPIエンドポイントから取得する必要がある
  // 一時的にプレースホルダーまたはデフォルト値を表示
  const assignedCount = "-"; // TODO: 実際のユーザー数APIから取得
  const totalCount = "-"; // TODO: 実際の総数APIから取得
  const status = software.operationalStatus?.usageStatus || "不明";
  const renewalDate = "-"; // TODO: 契約情報APIから取得

  return (
    <HStack className="ml-auto items-start gap-8">
      <VStack className="justify-between h-full">
        <Text
          variant={TextVariant.labelSmall}
          className="text-neutral-muted-on-fill"
        >
          {t("assignedTotal")}
        </Text>
        <HStack className="items-baseline gap-1">
          <Text variant={TextVariant.labelLarge}>{assignedCount}</Text>
          <Text
            variant={TextVariant.labelSmall}
            className={"text-neutral-muted-on-fill"}
          >
            {` / ${totalCount}`}
          </Text>
        </HStack>
      </VStack>
      <Separator orientation="vertical" />
      <VStack className="justify-between h-full">
        <Text
          variant={TextVariant.labelSmall}
          className="text-neutral-muted-on-fill"
        >
          {t("status")}
        </Text>
        <Badge variant="mutedSuccess">
          <Icon iconName="Check" className="mr-2 h-4 w-4" />
          <Text variant={TextVariant.label}>{status}</Text>
        </Badge>
      </VStack>
      <Separator orientation="vertical" />
      <VStack className="justify-between h-full">
        <Text
          variant={TextVariant.labelSmall}
          className="text-neutral-muted-on-fill"
        >
          {t("renewalDate")}
        </Text>
        <Text variant={TextVariant.labelLarge}>{renewalDate}</Text>
      </VStack>
    </HStack>
  );
}
